import Utils from "../utils/utils";
import * as i0 from "@angular/core";
var GlobalStoreService = /** @class */ (function () {
    function GlobalStoreService() {
        this.currentResource = null;
        this.imageFormat = Utils.shouldNotUseWebp() ? "jpg" : "webp";
    }
    GlobalStoreService.ngInjectableDef = i0.defineInjectable({ factory: function GlobalStoreService_Factory() { return new GlobalStoreService(); }, token: GlobalStoreService, providedIn: "root" });
    return GlobalStoreService;
}());
export { GlobalStoreService };
